import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Pagination, Segment } from 'semantic-ui-react';

import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import TitleBar from '../titleBar/titleBar';
import { gridHeader } from './receivable.constant';
import ReceivableActionButton from './receivableActionButton';

import { approvePayments, rejectPayments } from '../../redux/actions/approvalActions';
import { deleteReceivable, getFilteredReceivables, getReceivables } from '../../redux/actions/receivableActions';

function ReceivablesTable(props) {

    const { receivableData, receivableLoading, getReceivables, deleteReceivable, deleteReceivableIsLoading, approveReceivables, rejectReceivables, getFilteredReceivables, paginationData } = props;

    const [selectedRows, setSelectedRows] = useState([]);
    const [activeSelect, setActiveSelect] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState()
    const [itemCount, setItemCount] = useState(10)
    const [loadingData, setLoadingData] = useState(false)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [rowData, setRowData] = useState([])
    const [grid, setGrid] = useState({});
    let perPageItems = [
        {
            key: "1",
            text: "10",
            value: "10",
        },
        {
            key: "2",
            text: "20",
            value: "20",
        },
        {
            key: "3",
            text: "30",
            value: "30",
        },
        {
            key: "4",
            text: "50",
            value: "50",
        },
    ];

    useEffect(() => {
        getReceivables(itemsPerPage, searchValue, currentPage)
    }, [getReceivables]);

    useEffect(() => {
        if (paginationData) {
            setCurrentPage(paginationData.currentPage)
            setItemsPerPage(paginationData.itemsPerPage)
            setItemCount(paginationData.totalItems)
            setTotalPages(paginationData.totalPages)
        }
    }, [paginationData])

    const getSelectedRows = (grid) => {
        const selected = grid.api.getSelectedRows()
        setGrid(grid)
        setSelectedRows(selected);
        if (selected.length > 0) {
            setActiveSelect(true)
        } else {
            setActiveSelect(false)
        }
    }

    const approvePaymentsSelected = () => {
        let payementDetails = [];
        selectedRows && selectedRows.map((o, i) => {
            let temp = {};
            temp.paymentReferenceNo = o.refNo
            temp.vendorCode = o.vendorCode
            temp.approvalStatus = "Approved"
            payementDetails[i] = temp
        })

        const approveData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            payementDetails: payementDetails
        }
        approvePayments(approveData)
    };

    const rejectPaymentsSelected = () => {
        let payementDetails = [];
        selectedRows && selectedRows.map((o, i) => {
            let temp = {};
            temp.paymentReferenceNo = o.refNo
            temp.vendorCode = o.vendorCode
            temp.approvalStatus = "Rejected"

            payementDetails[i] = temp
        })

        const rejectData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            payementDetails: payementDetails
        }

        rejectPayments(rejectData)
    }

    const handleSelectAll = () => {
        grid.api.selectAll()
    }

    const handleUnSelectAll = () => {
        grid.api.deselectAll()
    }

    const handleCancel = () => {
        grid.api.deselectAll();
        setActiveSelect(false);
    }

    const getFilterDates = (startDate, endDate) => {
        const filteredData = {
            api_token: localStorage.getItem('apiToken'),
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            fromDate: moment(startDate).format("DD-MM-YYYY"),
            toDate: moment(endDate).format("DD-MM-YYYY")
        }

        getFilteredReceivables(filteredData)
    }

    const refreshDates = () => {
        window.location.reload();
    }

    const handlePaginationChange = (e, { activePage }) => {
        setCurrentPage(activePage)
        setLoadingData(true)
        setRowData([])
        getReceivables(itemsPerPage, searchValue, activePage)
    }

    const handleSearch = (e) => {
        e.stopPropagation()
        setRowData([])
        if (e.key === 'Enter') {
            setSearchValue(e.target.value)
            getReceivables(itemsPerPage, e.target.value, 1)
        }

    }

    const handlePagination = (e, data) => {
        e.stopPropagation()
        setRowData([])
        setCurrentPage(1)
        setItemsPerPage(data.value)
        getReceivables(data.value, searchValue, 1)
    }

    if (receivableLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Receivables" LinkName="add-receivable" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            // { headerName: 'Payment Receipt No.', field: 'paymentRecieptNo', headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true, tooltipField: 'paymentNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.refNo || 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.customerName || 'Customer Name', field: 'customerName', tooltipField: 'customerName', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Vendor Group', field: 'vendorGroup', tooltipField: 'vendorGroup', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.paymentAmount || 'Payment Amount', field: 'paymentAmount', tooltipField: 'paymentAmount', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Payment Mode', field: 'paymentMode', tooltipField: 'paymentMode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.paymentDate || 'Payment Date', field: 'paymentDate', tooltipField: 'paymentDate', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Status', field: 'status', tooltipField: 'status', enableRowGroup: true, enablePivot: true, filter: true , 
            //     cellStyle: params => {
            //         if(params.value === 'Approved'){
            //             return { color: 'green'}
            //         } else if (params.value === 'Rejected') {
            //             return { color: 'red'}
            //         } else {
            //             return { color: 'grey'}
            //         } 
            //     }
            // },
            { headerName: gridHeader.createdOn || 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.createdBy || 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.modifiedOn || 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.modifiedBy || 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: gridHeader.edit || 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" }
        ]

        let frameworkComponents = {
            actionRenderer: ReceivableActionButton,
        }

        let rowData = []

        receivableData && receivableData.forEach((object, index) => {
            let temp = {}
            // temp.paymentRecieptNo = object.paymentNo
            temp.paymentId = object.id
            temp.refNo = object.reference_number
            temp.customerName = object.client_name
            temp.customerCode = object.client_code
            // temp.vendorGroup = ''
            temp.paymentAmount = object.payment_amount
            temp.paymentMode = object.paymentModeName
            temp.paymentDate = moment(object.payment_date).format('DD-MM-YYYY') === 'Invalid date' ? '' : moment(object.payment_date).format('DD-MM-YYYY')
            temp.status = object.approvalStatus
            temp.createdOn = object.created_at
            temp.createdBy = object.created_by_name
            temp.modifiedOn = object.updated_at
            temp.modifiedBy = object.updated_by_name
            temp.deleteReceivable = deleteReceivable
            temp.isLoading = deleteReceivableIsLoading
            rowData[index] = temp
        })

        const pendingBills = receivableData ? receivableData.filter(receivable => receivable.approvalStatus === 'Pending').length : ''
        const approvedBills = receivableData ? receivableData.filter(receivable => receivable.approvalStatus === 'Approved').length : ''
        const rejectedBills = receivableData ? receivableData.filter(receivable => receivable.approvalStatus === 'Rejected').length : ''

        const approvalData = {
            pending: pendingBills,
            approved: approvedBills,
            rejected: rejectedBills
        }

        const newPopup = () => {
            props.history.push('/add-receivable')
        }

        return (
            <React.Fragment>
                <div style={{ position: 'relative' }}>
                    <AgGridTable
                        customizedSearch={true}
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={searchValue}
                        link="/add-receivable"
                        baseURL={props}
                        newPopup={newPopup}
                        hiddenNewPopupBtn={false}
                        hiddenImportPopupBtn={true}
                        extraComponents={frameworkComponents}
                        titleBarTitle="Receivables"
                        handleSearch={handleSearch}
                        rowSelected={getSelectedRows}
                        approvalCountSection={true}
                        approvalData={approvalData}
                        dateFilter={true}
                        getFilterDates={getFilterDates}
                        refreshDates={refreshDates}
                        suppressRowSelection={true}
                        removeStatus={true}
                        pagination={false}
                    />
                    <div className="life-cycle w3-white ui pagination menu">
                        <Pagination
                            defaultActivePage={currentPage}
                            firstItem={null}
                            lastItem={null}
                            onPageChange={handlePaginationChange}
                            pointing
                            secondary
                            totalPages={totalPages}
                        />
                        <Dropdown
                            options={perPageItems}
                            size="mini"
                            className="m-1"
                            placeholder="10"
                            selection
                            value={itemsPerPage}
                            defaultValue={"10"}
                            onChange={handlePagination}
                            compact
                        />
                    </div>
                    {activeSelect ?


                        <Segment
                            style={{ position: 'absolute', bottom: 12, left: 0 }}
                        >
                            <span style={{ color: 'grey', fontSize: '14px' }}>{`Selected (${selectedRows.length}/${receivableData.length}) `}</span>
                            {selectedRows.length === receivableData.length ?
                                <Button onClick={handleUnSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>UnSelect All</Button>
                                :
                                <Button onClick={handleSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>Select All</Button>

                            }
                            <Button onClick={approvePaymentsSelected} size="mini" basic color="blue" style={{ marginLeft: '5px', borderRadius: '25px' }}>Approve</Button>
                            <Button onClick={rejectPaymentsSelected} size="mini" basic color="red" style={{ marginLeft: '5px', borderRadius: '25px' }}>Reject</Button>
                            <Button type="button" onClick={handleCancel} size="mini" style={{ marginLeft: '5px', borderRadius: '25px' }}>Cancel</Button>
                        </Segment>

                        :

                        ""
                    }
                </div>
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    receivableData: state.getReceivableData.receivables.data,
    paginationData: state.getReceivableData.receivables.pagination,
    receivableLoading: state.getReceivableData.isLoading,
    deleteReceivableIsLoading: state.deleteReceivableData.isLoading
})

export default connect(mapStatetoProps, { getReceivables, deleteReceivable, approvePayments, rejectPayments, getFilteredReceivables })(ReceivablesTable)